var _animate, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "scale(0.8)",
      transformOrigin: "50px 50px"
    },
    strokeLinecap: "round",
    d: "M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z",
    strokeDasharray: "42.76482137044271 42.76482137044271",
    strokeWidth: 8,
    stroke: "#ff9900",
    fill: "none"
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    values: "0;256.58892822265625",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "stroke-dashoffset"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreLoader);
export default __webpack_public_path__ + "static/media/preLoader.3098f1686b2d98bed30172359f17db37.svg";
export { ForwardRef as ReactComponent };